const configDev = {
  baseURL: process.env.REACT_APP_DOMAIN_DEV,
  clientId: process.env.REACT_APP_CLIENT_ID_DEV,
  workInstructionBucket: process.env.REACT_APP_WORK_INSTRUCTION_BUCKET_DEV,
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION_DEV,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_DEV,
  aws_cognito_region: process.env.REACT_APP_AWS_PROJECT_REGION_DEV,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID_DEV,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_DEV,
  oauth: {},
  Auth: {
    endpoint: process.env.REACT_APP_AUTH_ENDPOINT_DEV,
    identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_DEV,
    region: process.env.REACT_APP_AWS_COGNITO_REGION_DEV,
    userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID_DEV,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_DEV,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_STORAGE_BUCKET_DEV,
      region: process.env.REACT_APP_STORAGE_REGION_DEV,
    },
  },
  avatar_dicebear_url: process.env.REACT_APP_AVATAR_DICEBEAR 
};

const configQa = {
  baseURL: process.env.REACT_APP_DOMAIN_QA,
  clientId: process.env.REACT_APP_CLIENT_ID_QA,
  workInstructionBucket: process.env.REACT_APP_WORK_INSTRUCTION_BUCKET_QA,
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION_QA,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_QA,
  aws_cognito_region: process.env.REACT_APP_AWS_PROJECT_REGION_QA,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID_QA,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_QA,
  oauth: {},
  Auth: {
    endpoint: process.env.REACT_APP_AUTH_ENDPOINT_QA,
    identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_QA,
    region: process.env.REACT_APP_AWS_COGNITO_REGION_QA,
    userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID_QA,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_QA,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_STORAGE_BUCKET_QA,
      region: process.env.REACT_APP_STORAGE_REGION_QA,
    },
  },
  avatar_dicebear_url: process.env.REACT_APP_AVATAR_DICEBEAR
};

const configProd = {
  baseURL: process.env.REACT_APP_DOMAIN_PROD,
  clientId: process.env.REACT_APP_CLIENT_ID_PROD,
  workInstructionBucket: process.env.REACT_APP_WORK_INSTRUCTION_BUCKET_PROD,
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION_PROD,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_PROD,
  aws_cognito_region: process.env.REACT_APP_AWS_PROJECT_REGION_PROD,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID_PROD,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_PROD,
  oauth: {},
  Auth: {
    endpoint: process.env.REACT_APP_AUTH_ENDPOINT_PROD,
    identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_PROD,
    region: process.env.REACT_APP_AWS_COGNITO_REGION_PROD,
    userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID_PROD,
    userPoolWebClientId:
      process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_PROD,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_STORAGE_BUCKET_PROD,
      region: process.env.REACT_APP_STORAGE_REGION_PROD,
    },
  },
  avatar_dicebear_url: process.env.REACT_APP_AVATAR_DICEBEAR
};


const configFailover = {
  baseURL: process.env.REACT_APP_DOMAIN_FAILOVER,
  clientId: process.env.REACT_APP_CLIENT_ID_FAILOVER,
  workInstructionBucket: process.env.REACT_APP_WORK_INSTRUCTION_BUCKET_FAILOVER,
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION_FAILOVER,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_FAILOVER,
  aws_cognito_region: process.env.REACT_APP_AWS_PROJECT_REGION_FAILOVER,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID_FAILOVER,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_FAILOVER,
  oauth: {},
  Auth: {
    endpoint: process.env.REACT_APP_AUTH_ENDPOINT_FAILOVER,
    identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_FAILOVER,
    region: process.env.REACT_APP_AWS_COGNITO_REGION_FAILOVER,
    userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID_FAILOVER,
    userPoolWebClientId:
      process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_FAILOVER,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_STORAGE_BUCKET_FAILOVER,
      region: process.env.REACT_APP_STORAGE_REGION_FAILOVER,
    },
  },
  avatar_dicebear_url: process.env.REACT_APP_AVATAR_DICEBEAR
};

const configSandbox1 = {
  baseURL: process.env.REACT_APP_DOMAIN_SANDBOX_1,
  clientId: process.env.REACT_APP_CLIENT_ID_SANDBOX_1,
  workInstructionBucket:
    process.env.REACT_APP_WORK_INSTRUCTION_BUCKET_SANDBOX_1,
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION_SANDBOX_1,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_SANDBOX_1,
  aws_cognito_region: process.env.REACT_APP_AWS_PROJECT_REGION_SANDBOX_1,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID_SANDBOX_1,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_SANDBOX_1,
  oauth: {},
  Auth: {
    endpoint: process.env.REACT_APP_AUTH_ENDPOINT_SANDBOX_1,
    identityPoolId:
      process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_SANDBOX_1,
    region: process.env.REACT_APP_AWS_COGNITO_REGION_SANDBOX_1,
    userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID_SANDBOX_1,
    userPoolWebClientId:
      process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_SANDBOX_1,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_STORAGE_BUCKET_SANDBOX_1,
      region: process.env.REACT_APP_STORAGE_REGION_SANDBOX_1,
    },
  },
  avatar_dicebear_url: process.env.REACT_APP_AVATAR_DICEBEAR
};

const configSandbox2 = {
  baseURL: process.env.REACT_APP_DOMAIN_SANDBOX_2,
  clientId: process.env.REACT_APP_CLIENT_ID_SANDBOX_2,
  workInstructionBucket:
    process.env.REACT_APP_WORK_INSTRUCTION_BUCKET_SANDBOX_2,
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION_SANDBOX_2,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_SANDBOX_2,
  aws_cognito_region: process.env.REACT_APP_AWS_PROJECT_REGION_SANDBOX_2,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID_SANDBOX_2,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_SANDBOX_2,
  oauth: {},
  Auth: {
    endpoint: process.env.REACT_APP_AUTH_ENDPOINT_SANDBOX_2,
    identityPoolId:
      process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_SANDBOX_2,
    region: process.env.REACT_APP_AWS_COGNITO_REGION_SANDBOX_2,
    userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID_SANDBOX_2,
    userPoolWebClientId:
      process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_SANDBOX_2,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_STORAGE_BUCKET_SANDBOX_2,
      region: process.env.REACT_APP_STORAGE_REGION_SANDBOX_2,
    },
  },
  avatar_dicebear_url: process.env.REACT_APP_AVATAR_DICEBEAR
};

const configTest01 = {
  baseURL: process.env.REACT_APP_DOMAIN_TEST01,
  clientId: process.env.REACT_APP_CLIENT_ID_TEST01,
  workInstructionBucket: process.env.REACT_APP_WORK_INSTRUCTION_BUCKET_TEST01,
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION_TEST01,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_TEST01,
  aws_cognito_region: process.env.REACT_APP_AWS_PROJECT_REGION_TEST01,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID_TEST01,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_TEST01,
  oauth: {},
  Auth: {
    endpoint: process.env.REACT_APP_AUTH_ENDPOINT_TEST01,
    identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_TEST01,
    region: process.env.REACT_APP_AWS_COGNITO_REGION_TEST01,
    userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID_TEST01,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_TEST01,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_STORAGE_BUCKET_TEST01,
      region: process.env.REACT_APP_STORAGE_REGION_TEST01,
    },
  },
  avatar_dicebear_url: process.env.REACT_APP_AVATAR_DICEBEAR
};

const configTest02 = {
  baseURL: process.env.REACT_APP_DOMAIN_TEST02,
  clientId: process.env.REACT_APP_CLIENT_ID_TEST02,
  workInstructionBucket: process.env.REACT_APP_WORK_INSTRUCTION_BUCKET_TEST02,
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION_TEST02,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_TEST02,
  aws_cognito_region: process.env.REACT_APP_AWS_PROJECT_REGION_TEST02,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID_TEST02,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_TEST02,
  oauth: {},
  Auth: {
    endpoint: process.env.REACT_APP_AUTH_ENDPOINT_TEST02,
    identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_TEST02,
    region: process.env.REACT_APP_AWS_COGNITO_REGION_TEST02,
    userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID_TEST02,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_TEST02,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_STORAGE_BUCKET_TEST02,
      region: process.env.REACT_APP_STORAGE_REGION_TEST02,
    },
  },
  avatar_dicebear_url: process.env.REACT_APP_AVATAR_DICEBEAR
};

const configDemo = {
  baseURL: process.env.REACT_APP_DOMAIN_DEMO,
  clientId: process.env.REACT_APP_CLIENT_ID_DEMO,
  workInstructionBucket: process.env.REACT_APP_WORK_INSTRUCTION_BUCKET_DEMO,
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION_DEMO,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_DEMO,
  aws_cognito_region: process.env.REACT_APP_AWS_PROJECT_REGION_DEMO,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID_DEMO,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_DEMO,
  oauth: {},
  Auth: {
    endpoint: process.env.REACT_APP_AUTH_ENDPOINT_DEMO,
    identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID_DEMO,
    region: process.env.REACT_APP_AWS_COGNITO_REGION_DEMO,
    userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID_DEMO,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID_DEMO,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_STORAGE_BUCKET_DEMO,
      region: process.env.REACT_APP_STORAGE_REGION_DEMO,
    },
  },
  avatar_dicebear_url: process.env.REACT_APP_AVATAR_DICEBEAR
};

const getConfig = () => {
  switch (process.env.REACT_APP_PLATFORM_ENV) {
    case "DEV":
      return configDev;
    case "QA":
      return configQa;
    case "PROD":
      return configProd;
    case "SANDBOX01":
      return configSandbox1;
    case "SANDBOX02":
      return configSandbox2;
    case "FAILOVER":
      return configFailover;
    case "TEST01":
      return configTest01;
    case "TEST02":
      return configTest02;
    case "DEMO":
        return configDemo;
    default:
      return configQa;
  }
};
const config = getConfig();
export { config };
